module.exports = __webpack_public_path__ + "img/vip_tit_img.cfe73efa.png";